import React from 'react';

const ForecastingHubHeader: React.FC = () => {
  return (
    <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        {/* Title & Description */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Forecasting Hub</h1>
          <p className="mt-1 text-sm text-gray-600">
            Plan for profitability and predict cash flow — essential tools for financial planning
          </p>
        </div>

        {/* Quick Info Cards */}
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
              <span className="text-lg">⚖️</span>
            </div>
            <div>
              <div className="text-xs text-gray-500">Break-Even</div>
              <div className="text-sm font-semibold text-gray-900">Units & Revenue</div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-100">
              <span className="text-lg">💸</span>
            </div>
            <div>
              <div className="text-xs text-gray-500">Cash Flow</div>
              <div className="text-sm font-semibold text-gray-900">3-6 Month Forecast</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForecastingHubHeader;
